// Subida de imágenes a InsForge Storage (bucket público "fotos-productos").
// Devuelve la URL pública para guardarla en producto.foto y mostrarla en <img>.
import { insforge } from '../insforge';

const BUCKET = 'fotos-productos';

export async function subirFoto(file: File): Promise<string> {
  const ext = file.name.includes('.') ? file.name.split('.').pop() : 'jpg';
  const path = `productos/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
  const { data, error } = await insforge.storage.from(BUCKET).upload(path, file);
  if (error || !data) throw new Error(error?.message ?? 'No se pudo subir la imagen');
  return data.url;
}
